








































































































































import Vue from 'vue'

import RequestProduct from '@/groupBuy/components/requestList/RequestProduct.vue'
import InputSizeItem from '@/groupBuy/components/requestList/InputSizeItem.vue'
import NewInputSizeCtrl from '@/groupBuy/components/requestList/NewSizeInputCtrl.vue'
import PrintingOptionModal from '@/groupBuy/components/requestList/PrintingOptionModal.vue'

import { clipboardCopy } from '@/common/copy'
import {
  RequestItemModel
} from '@/groupBuy/types'
import { getInputSizeByRequest, expiredDateFormat } from '@/groupBuy/utils'
import { priceFormatter } from '@/common/utils'
import { formatOneDecimal } from '@/common/utils/common'
import service from '@/groupBuy/services'
import { SYSTEM_ERROR } from '@/common/constants'
import { ActionTypes, MutationTypes } from '@/groupBuy/requestList/store/type'

const GROUP_BUY_CHANNEL = 'GroupBuyItemChannel'

export default Vue.extend({
  components: {
    RequestProduct,
    InputSizeItem,
    NewInputSizeCtrl,
    PrintingOptionModal
  },
  props: {
    request: {
      type: Object as () => RequestItemModel,
      required: true
    }
  },
  data(): {
    printingOptionModalVisible: boolean
  } {
    return {
      printingOptionModalVisible: false
    }
  },
  computed: {
    inputSizeUrl(): string {
      return getInputSizeByRequest(this.request.uuid)
    },
    productName(): string {
      return this.request.printableSku.sku.product.displayName || ''
    },
    productUrl(): string {
      return `${this.request.printableSku.sku.product.url}?psi=${this.request.printableSku.id}`
    },
    expiredDateFormatted(): string {
      const date = this.request.expiredDate ? new Date(this.request.expiredDate) : null
      return expiredDateFormat(date)
    },
    totalPriceFormatted(): string {
      return priceFormatter(this.request.amount)
    },
    quantityUnit(): string {
      return this.request.printableSku.sku.product.quantityUnit
    },
    validQuantity(): boolean {
      return this.request.sizeItems.some(item => item.quantity > 0)
    },
    totalQuantityDisplay(): string {
      return formatOneDecimal(this.request.quantity || 0) + this.quantityUnit
    },
    addedToCart(): boolean {
      return this.request.addedToCart
    },
    isFastShippingProduct(): boolean {
      const product = this.request.printableSku.sku.product
      return !!product.normalProductId && !product.fastShippingProductId
    },
    isPlainGoodFastShipping(): boolean {
      const product = this.request.printableSku.sku.product
      return product.plainGoodFastShipping
    }
  },
  channels: {
    computed: [
      {
        channelName() {
          return `${GROUP_BUY_CHANNEL}_${this.request.uuid}`
        },
        received(data: {uuid: string, createdAt: string}) {
          this.$store.commit(MutationTypes.SET_NOTIFICATION, {[data.uuid]: data.createdAt})
          this.updateRequestData()
        }
      }
    ]
  },
  created() {
    this.$cable.subscribe({
      channel: GROUP_BUY_CHANNEL,
      room: `group_buy_item_${this.request.uuid}`,
      params: {
        uuid: this.request.uuid
      }
    }, `${GROUP_BUY_CHANNEL}_${this.request.uuid}`)
  },
  methods: {
    copyLink() {
      clipboardCopy(this.inputSizeUrl)
      alert('リンクをコピーしました')
    },
    async deleteRequest() {
      const result = confirm('ご依頼を削除しますか？(OKを押すと削除されます)')
      if (result) {
        const res = await service.deleteRequest(this.request.uuid).catch(() => {
          alert(SYSTEM_ERROR.UNKNOWN)
        })
        if (res) {
          this.$store.dispatch(ActionTypes.REMOVE_REQUEST, this.request.uuid)
        }
      }
    },
    updateRequestData() {
      this.$emit('refreshInputSizeList', this.request.uuid)
    },
    toggleAcceptingInput(value: boolean) {
      service.updateRequestAcceptInputStatus(this.request.uuid, value).then(res => {
        if (!res?.lockGroupBuyItem?.errors.length) {
          const { isLock } = res.lockGroupBuyItem.groupBuyItem
          this.$store.commit(MutationTypes.UPDATE_REQUEST_ACCEPTING_INPUT, {
            requestUuid: this.request.uuid,
            acceptingInput: value,
            isLock: isLock
          })
        }
      }).catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
      })
    },
    addToCart() {
      service.addToCart(this.request.uuid).then(() => {
        location.href = '/cart'
      }).catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
      })
    },
    openPrintingOption() {
      this.printingOptionModalVisible = true
    }
  }
})
